import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { MatStepper } from '@angular/material/stepper';
import { SignupFormService } from '../signup-form.service';

declare var jQuery: any;

@Component({
    selector: 'app-signup-otp-verify',
    templateUrl: './signup-otp-verify.component.html',
    styleUrls: ['./signup-otp-verify.component.scss'],
    providers: [SignupFormService],
    standalone: false
})
export class SignupOtpVerifyComponent implements OnInit, OnDestroy  {
  loading: boolean = false
  isResendAllowed: boolean = true;

  otpVerifyErrorMsg: string = '';
  otpVerifyErrorFlag: boolean = false;

  @Input() sessionId: string
  @Input() name: string
  @Input() emailId: string;
  @Input() timeLeft: number;

  @Output()  close = new EventEmitter();
  @Output()  signup = new EventEmitter();

  @ViewChild('inp1') inp1: ElementRef;
  @ViewChild('inp2') inp2: ElementRef;
  @ViewChild('inp3') inp3: ElementRef;
  @ViewChild('inp4') inp4: ElementRef;
  @ViewChild('verifyBtn') verifyBtn: ElementRef;

  verifyOtpFormGroup = this._formBuilder.group({
    inp1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    inp2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    inp3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
    inp4: ['', [Validators.required, Validators.pattern('^[0-9]$')]]
  });

  timerSubscription: Subscription;
  displayTime: string;

  constructor(private _formBuilder: FormBuilder, private signupFormService: SignupFormService) { 

  }

  ngOnInit() {
    this.startTimer();
  }

  ngAfterViewInit() {
    setTimeout(() => { 
      this.inp1.nativeElement.focus();
    }, 0);
  }

  private startTimer() {
      this.timerSubscription = interval(1000).subscribe(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
          this.displayTime = this.formatTime(this.timeLeft);
        } else {
          this.stopTimer();
          this.close.emit('OTP has expired. Please try again.');
        }
      });
    }
  
    private stopTimer() {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
    }
  
    private formatTime(seconds: number): string {
      const minutes: number = Math.floor(seconds / 60);
      const remainingSeconds: number = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }
  
    public onInput(event: Event) {
      const input = event.target as HTMLInputElement;
      const newValue = input.value.slice(0, 1);

      if (input.value.length > 1) {
        this.verifyOtpFormGroup.get(input.id).setValue(newValue);
      }

      if (newValue.length === 1) {
        this.moveToNextInput(input);
      }
    }

    private setFocusAndSelect(input: ElementRef) {
      input.nativeElement.focus();
      input.nativeElement.select();
    }
  
    private moveToNextInput(input: HTMLInputElement) {
      switch (input.id) {
        case 'inp1':
          this.setFocusAndSelect(this.inp2);
          break;
        case 'inp2':
          this.setFocusAndSelect(this.inp3);
          break;
        case 'inp3':
          this.setFocusAndSelect(this.inp4);
          break;
        case 'inp4':
          setTimeout(() => {
            this.verifyBtn.nativeElement.focus();
          }, 0);
          break;
      }
    }

    public onKeydown(event: KeyboardEvent) {
      if(["e", "E", "+", "-"].includes(event.key)) {
        event.preventDefault()
      }
    }

    onResendCodeClick() {
      this.loading = true;
      const payload = {
        "sessionId": this.sessionId,
        "name": this.name,
        "email": this.emailId
      };

      this.signupFormService.resendSignupOTP(payload).subscribe((response) => {
        if(response && response['status'] === 'Success') {
          this.timeLeft = response['expirySeconds'];
          this.isResendAllowed = false;
        }
        this.loading = false;
      },
      (error) => {
        this.isResendAllowed = true;
        this.loading = false;
      });
    }

    public onVerifyBtnClick() {
      this.otpVerifyErrorMsg = '';
      const otp = '' + this.verifyOtpFormGroup.value.inp1 + this.verifyOtpFormGroup.value.inp2 + 
          this.verifyOtpFormGroup.value.inp3 + this.verifyOtpFormGroup.value.inp4;

      if(otp.length != 4) {
        this.otpVerifyErrorMsg = 'Please enter the OTP received on your email address!';
        return;
      }

      this.loading = true;

      const payload = {
        "sessionId": this.sessionId,
        "otp": otp,
        "email": this.emailId
      };

      this.signupFormService.verifySignupOTP(payload).subscribe((data) => {
          const response = {
            status: 'Success'
          }

          this.signup.emit(response);
          this.loading = false;
      },
      (error) => {
          this.loading = false;
          if(error && error.error["status"] === "Wrong OTP"){
            this.otpVerifyErrorMsg = 'The OTP you entered is invalid. Please enter the correct OTP!';
            this.timeLeft = 30;
          } 
          else if(error && error.error["status"] === "Reached Max Attempts"){
            this.close.emit('The OTP you entered is invalid and you have reached the maximum number of unsuccessful attempts. Please try again later!');
          } 
          else {
            const response = {
              status: 'Error'
            }
            this.signup.emit(response);
          }
      }); 
    }

    onCloseBtnClick() { 
      this.close.emit();
    }

    ngOnDestroy() {
      this.stopTimer();
    }
}